import SegmentedControl, {
  SegmentedControlProps,
} from "@react-native-segmented-control/segmented-control";
import React from "react";

type T = React.FC<SegmentedControlProps>;
export const AHSegmentedControl = SegmentedControl as unknown as T;
